/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getVirtualOfficeCompanyList = /* GraphQL */ `query GetVirtualOfficeCompanyList($dummy: String) {
  getVirtualOfficeCompanyList(dummy: $dummy) {
    zhName
    enName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVirtualOfficeCompanyListQueryVariables,
  APITypes.GetVirtualOfficeCompanyListQuery
>;
export const retrieveVOClients = /* GraphQL */ `query RetrieveVOClients {
  retrieveVOClients {
    zhName
    enName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RetrieveVOClientsQueryVariables,
  APITypes.RetrieveVOClientsQuery
>;
